import React, { useState, useEffect,useContext } from "react";
import { AppContext } from "../../AppContext";

import { fetchCall } from "../../common/FetchHelpers";
import DateUtil from "../../common/dateUtil";

import LoadingComp from "../common/LoadingComp";

import ReqControlHeader from "../common/ReqControlHeader";
import RequestTemplateService from "../../services/RequestTemplateService";
import ObaSearchComp from "./ObaSearchComp";
import ObaEditorComp from "./ObaEditorComp";

const ObaComp = (props) => {

  const summaryUrl = "api/oba/reqsummary";

  const [appContext, setAppContext] = useContext(AppContext);
  
  
  const emptyEditorItem = {   
    id:-1,
    status:"",
    businessName : "",
    businessType : "",
    businessDesc : "",
    businessAddress : "",
    yearlyIncome : "",
    compensationMethod : "",
    engagementTime : "",
    businessStructure : "",
    activityStartDate : "",
    isBusinessCustody:"",
    businessCustody : "",
    attachment:null,

    isDba : "",
    isDbaHomeState:"",
    titlePosition:"",
    businessOrganizationName:"",
    isClientOwnSecurity:"",
    clientAccount:"",
    rdoPartnerType:"",
    partnerType:"",
    businessRelations:[],
    otherBusinessRelation:"",
    businessDuty:"",
    businessUrl:"",
    isInvestSecurity:"",
    isFundraising:"",
    fundraisingDesc:"",
    isInvestmentRep:"",
    isEngageMoreThan10Percent:"",
    isIncomeMoreThan10Percent:"",
    isSolicitedInvest:"",
    solicitedInvestors:[{investorName:"",investorRelation:"",investmentAmount:"",investmentDate:"",involvementType:""}],
    isActivityInvolve:"",
    activityInvolvedPeople:[{name:"",accountNumbers:"",involvementType:""}],
    requiresTwoSignCheck:"",
    insuranceCovered:"",
    otherInfo:"",
    complyAudit:"",
    complyFee:"",
    complySolicitation:""
  }
  
  const [showingList, setShowingList] = useState(true);
  const [showingEditor, setShowingEditor] = useState(false);
  const [showError, setShowError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [editorItem, setEditorItem] = useState(emptyEditorItem);
  const [template, setTemplate] = useState("");
  const [editorMode, setEditorMode] = useState("NEW");
  
  const addNewClickHandler = () => {
    setEditorItem(emptyEditorItem);
    setControlParam((p) => {
      return { ...p, mode: "add" };
    });
    
    setShowingList(false);
    setShowingEditor(true);
  };
  
  const showListHandler = () => {
    setControlParam((p) => {
      return { ...p, mode: "view" };
    });
    setShowingEditor(false);
    setShowingList(true);
  };
  
  const handleUpdate=(data)=>{
    setEditorMode("UPDATE");
    const activityStartDate = DateUtil.toDate(data.activityStartDate);
    const item = {
      ...data,
      activityStartDate,
      isBusinessCustody:data.businessCustody?"Yes":"No",
      businessCustody:data.businessCustody===null?"":data.businessCustody
    };
     
    setEditorItem(item);
    setShowingList(false);
    setShowingEditor(true);
  };
  
  
  const [controlParam, setControlParam] = useState({
    approved: 0,
    pending: 0,
    rejected: 0,
    btnAddLabel: "Create a New Request",
    mode: "view",
    addNewClickHandler,
    showListHandler,
  });
  


  const fetchTemplate = () => {
    RequestTemplateService.GetOba()
        .then((template) => {
          if(template){
            setTemplate(template);
          }
        });
  };
  
  useEffect(() => {
      fetchTemplate();
      fetchCall(summaryUrl)
        .then((result)=>{
          setControlParam({
            ...controlParam,
            approved: result.obaRequest.approved,
            pending: result.obaRequest.pending,
            rejected: result.obaRequest.rejected,
          });
          setLoading(false);
        },
        (err) => {
          setLoading(false);
          setShowError(true);
        });
  }, [appContext.reloadSummary]);

  return (
    <div className={appContext.sidebarCollapsed?"content-wrapper sidebar-collapsed":"content-wrapper"}>
      <section className="section-wrapper">
        <div className="page-title">Outside Business Activity Requests</div>
        <div className="section-content">
          <ReqControlHeader params={controlParam} />
          <div className="section-body">
            {showingList && <ObaSearchComp handleUpdate={handleUpdate} obaId={props.match.params.id} t={props.match.params.t}/>}
            {showingEditor && <ObaEditorComp handleClose={showListHandler} 
                               formData={{...editorItem, template: template}} editorMode={editorMode}/>}
            {loading && <LoadingComp />}
          </div>
        </div>
      </section>
    </div>
  );
};

export default ObaComp;
